import axios from "@/axios";

export default {
    update(payload) {
        return axios.post(`cabinet/client`, payload);
    },
    password(payload) {
        return axios.post(`cabinet/client/password`, payload);
    },
    bonus: {
        list(page) {
            return axios.get(`cabinet/client/bonuses?page=${page}`);
        },
        referrals(page, search = '') {
            return axios.get(`cabinet/client/referrals?page=${page}&search=${search}`);
        },
    },
    notification: {
        list(page) {
            return axios.get(`cabinet/client/notifications?page=${page}`);
        },
    },
    record: {
        list(payload) {
            return axios.get(`cabinet/client/records`, payload);
        },
    }
}
